import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogService } from '../../../../services/alert-dialog.service';
import { MissionsRejectedComponent } from '../../missions/missions-rejected/missions-rejected.component';
import { CandidatProfilComponent } from '../../missions/historique-component/condidat-profil/condidat-profil.component';
import { StatusEnum } from '../../../../shared/utils/enums';
import moment from 'moment';
import { MissionService } from '../../../../services/mission.service';
import { calculateDaysWithTime, displayImg } from '../../../../shared/utils/utils.functions';
import { ImageDialogComponent } from '../../../../shared/image-dialog/image-dialog.component';
import { AnonymizationService } from '../../../../services/anonymization.service';

@Component({
  selector: 'app-mission-details-1',
  templateUrl: './mission-details.component.html',
  styleUrl: './mission-details.component.scss',
})
export class PlanningMissionDetailsComponent implements OnInit {
  title: string;
  fichePosteFiles: any[] = [];
  fichePosteId = null;
  condidat: any[] = [
    {
      name: 'Mme. Mathilde Lefevre',
      status: 1,
      img: '/assets/images/user.png',
    },
    { name: 'Mr. Alexandre Lambert', status: 1 },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Charlotte Rousseau', status: 0 },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user2.png',
    },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: '{candidat.name}', status: 0, img: '/assets/images/user1.png' },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
  ];
  condidatAccepted: any[];
  condidatFilted: any[];
  rowData: any;
  diffDays: any;
  startDate: any;
  endDate: any;
  user: any;
  constructor(
    public dialogRef: MatDialogRef<PlanningMissionDetailsComponent>,
    private alertDialogService: AlertDialogService,
    private missionApi: MissionService,
    public anonymizationService: AnonymizationService,
    private dialog: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngOnInit(): void {
    this.condidatAccepted = this.condidat.filter((el) => el.status != 0);
    this.condidatFilted = this.condidat.filter((el) => el.status != 1);
    this.title = this.data.missionTitle || 'Mission ' + this.data.id;
    this.rowData = this.data;
    this.startDate = moment(
      new Date(this.data.startdate + ' ' + this.data.starttime)
    ).format('LLL');
    this.endDate = moment(
      new Date(this.data.enddate + ' ' + this.data.endtime)
    ).format('LLL');
    this.diffDays = calculateDaysWithTime(this?.data?.startDate, this?.data?.enddate, this?.data?.startTime
      ,this?.data?.endtime
    );

    this.fetchMissionByCandidatId();
  }
  onDialogClose(): void {
    this.dialogRef.close(this.data);
  }
  getFichePost() {
    this.missionApi
      .getFichePosteById(this.fichePosteId)
      .subscribe((res: any) => {
        //

        let file = new File(
          ['data:application/pdf;base64,' + res?.pdfContent],
          res?.name + '.pdf',
          {
            type: 'application/pdf',
          }
        );
        this.fichePosteFiles = [
          {
            file,
            url: 'data:application/pdf;base64,' + res.pdfContent,
          },
        ];
      });
  }
  confirmValidation() {
    this.alertDialogService
      ?.openAlertModal(
        'success',
        'Confirmation de validation de la mission',
        "Êtes-vous sûr(e) de vouloir valider cette mission ? Une fois validée, la mission sera marquée comme terminée et vous pourrez procéder à l'évaluation du candidat. Cette action est irréversible.",
        'Valider la mission',
        'Annuler',
        '550px',
        true
      )
      ?.subscribe((res: any) => {
        if (res) {
          this.router.navigate(['/dashboard/missions/validation']);
          this.onDialogClose();
        }
      });
  }
   openImage(img: any, missionStatus: string = '') {
    const dialog = this.dialog.open(ImageDialogComponent, {
      backdropClass: 'bg-transparent',
      data: {shouldAnonymize: this.anonymizationService.shouldAnonymize(missionStatus) , img},
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
      }
    });
  }
  fetchMissionByCandidatId() {
    this.missionApi
      .getMissionsByCondidatIdAndMissionId(this.data?.user?.id, this.data?.id, "/v2")
      .subscribe({
        next: (res) => {
          this.fichePosteId = res?.fichePosteId;
          this.rowData = res;
          if (this.fichePosteId) {
            this.getFichePost();
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  getFile(files: any, label: string): void {}
  condidatProfil(): void {
    this.dialog.open(CandidatProfilComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: this.data?.user,
    });
  }

  protected readonly displayImg = displayImg;

}
